import {
  ApplicantsApiClientInterface,
  ApplicantsApiClientModel,
  ApplicantsApiClientUrlsInterface,
  // ContactsApiClientOptions,
} from '../../../models/api-client/models';

const urls: ApplicantsApiClientUrlsInterface = {
  createApplicant: '/static/mock-data/applicants/applicants.json',
  fetchApplicants: '/static/mock-data/applicants/applicants.json',
};
// instantiate the ItemsApiClient pointing at the url that returns static json mock \
//data
const ApplicantsApiClient: ApplicantsApiClientInterface =
  new ApplicantsApiClientModel({
    urls,
    mockDelay: 1000,
  });
// export our instance
export {ApplicantsApiClient};
